/* tslint:disable */
/* eslint-disable */
/**
 * Prove Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHistories200ResponseHistoriesInner } from './GetHistories200ResponseHistoriesInner';
import {
    GetHistories200ResponseHistoriesInnerFromJSON,
    GetHistories200ResponseHistoriesInnerFromJSONTyped,
    GetHistories200ResponseHistoriesInnerToJSON,
    GetHistories200ResponseHistoriesInnerToJSONTyped,
} from './GetHistories200ResponseHistoriesInner';

/**
 * 
 * @export
 * @interface GetHistories200Response
 */
export interface GetHistories200Response {
    /**
     * 
     * @type {Array<GetHistories200ResponseHistoriesInner>}
     * @memberof GetHistories200Response
     */
    histories?: Array<GetHistories200ResponseHistoriesInner>;
}

/**
 * Check if a given object implements the GetHistories200Response interface.
 */
export function instanceOfGetHistories200Response(value: object): value is GetHistories200Response {
    return true;
}

export function GetHistories200ResponseFromJSON(json: any): GetHistories200Response {
    return GetHistories200ResponseFromJSONTyped(json, false);
}

export function GetHistories200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistories200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'histories': json['histories'] == null ? undefined : ((json['histories'] as Array<any>).map(GetHistories200ResponseHistoriesInnerFromJSON)),
    };
}

export function GetHistories200ResponseToJSON(json: any): GetHistories200Response {
    return GetHistories200ResponseToJSONTyped(json, false);
}

export function GetHistories200ResponseToJSONTyped(value?: GetHistories200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'histories': value['histories'] == null ? undefined : ((value['histories'] as Array<any>).map(GetHistories200ResponseHistoriesInnerToJSON)),
    };
}

